export const expirationDateFormat = (dateString) => {
  if (dateString && dateString !== 'undefined') {
    return dateString.split('-')[1] + ' / ' + dateString.split('-')[0];
  }
};

export const normalizePhoneNumber = (phone) =>
  phone.replace(/\D/g, '').slice(-12);

export const generateHash = (length: number) => {
  let result = '';
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export function interpolateString(
  template: string,
  data: Record<string, string>
) {
  const regex = /{(\w+)}/g;

  const result = template?.replace(regex, function (match, propertyName) {
    if (data.hasOwnProperty(propertyName)) {
      return data[propertyName];
    }
    return match;
  });

  return typeof result === 'string' ? result : '';
}

export function capitalizeFirstLetter(string: string) {
  if (!string || typeof string !== 'string') return string;
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function transformCardNumber(card = '') {
  return 'XXXX XXXX XXXX ' + card.slice(-4);
}

/**
 * Capitalizes first letters of words in string.
 * @param {string} str String to be modified
 * @param {boolean=false} lower Whether all other letters should be lowercased
 * @return {string}
 * @usage
 *   capitalize('fix this string');     // -> 'Fix This String'
 *   capitalize('javaSCrIPT');          // -> 'JavaSCrIPT'
 *   capitalize('javaSCrIPT', true);    // -> 'Javascript'
 */
export const capitalize = (str, lower = false) =>
  (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, (match) =>
    match.toUpperCase()
  );
